import React from 'react'

const LatestBooking = ({t,lang,latestBookings}) => {
  return (
    <div className="chart-card">
      <div className="chart-card-header">
        <strong>{t("latestBookings")}</strong>
        <i class="fas fa-ellipsis-vertical d-none"></i>
      </div>
      <div className="chart-card-body mt-1" style={{minHeight: "228px"}}>
        <table className="table">
          <tbody>
            {latestBookings?.map((item, index) => (
              <tr key={index}>
                <td className="d-flex align-items-center gap-1">
                 <span>{item?.name[lang]} </span>
                  <span className="badge bg-success text-white">
                    {t("completed")}
                  </span>
                 <span>{item?.totalCost} {t("riyal")}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LatestBooking